import { apiClient } from "@/lib/api-client";

export const getValidationStatus = async (
  niu: string,
  year: number | string,
  semester: number | string,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
  });

  const res = await apiClient<any>(
    `${baseUrl}/api/v1/validation-status/${niu}?${params.toString()}`,
    { cache: "no-store" },
  );

  return res;
};
